"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userKeys = void 0;
const protocol_crypto_1 = require("@moojo/protocol-crypto");
exports.userKeys = {
    privateKeyForSecret(secret) {
        return protocol_crypto_1.PrivateKey.fromSeeds(secret);
    },
    publicKeyForSecret(secret) {
        return protocol_crypto_1.PrivateKey.fromSeeds(secret).createPublic();
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci1rZXlzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxzL3VzZXIta2V5cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw0REFBbUQ7QUFFdEMsUUFBQSxRQUFRLEdBQUc7SUFDdEIsbUJBQW1CLENBQUMsTUFBYztRQUNoQyxPQUFPLDRCQUFVLENBQUMsU0FBUyxDQUFDLE1BQU0sQ0FBQyxDQUFBO0lBQ3JDLENBQUM7SUFFRCxrQkFBa0IsQ0FBQyxNQUFjO1FBQy9CLE9BQU8sNEJBQVUsQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLENBQUMsWUFBWSxFQUFFLENBQUE7SUFDcEQsQ0FBQztDQUNGLENBQUEifQ==